import { tableCellStackNarrowClassName } from '@/components/table/table-cell-stack-narrow';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/tailwind-utils';
import { ReactNode } from 'react';

interface GroupDividerLayoutProps {
  rowCount: number;
  children: ReactNode;
}

export function GroupDividerLayout({ rowCount, children }: GroupDividerLayoutProps) {
  return (
    <span className={cn('flex items-center gap-2 text-sm pl-3', tableCellStackNarrowClassName)}>
      {children}
      <Badge variant="secondary" className="bg-air-blue-subdued hover:bg-air-blue-subdued text-air-dark-blue">
        {rowCount}
      </Badge>
    </span>
  );
}
